var map = {
	"./IMG_2025-min.JPG": 435,
	"./IMG_2888-min.JPG": 436,
	"./IMG_4167-min.JPG": 437,
	"./IMG_4407-min.JPG": 438,
	"./Wohnen-min.jpg": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 434;